/* Ref Link for auth guard: https://codeburst.io/using-angular-route-guard-for-securing-routes-eabf5b86b4d1 */

import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    if (!this.authService.getLogflag()) {
      return this.router.createUrlTree(['/login'], {
        queryParams: { returnUrl: state.url },
      });
    }

    const user = this.authService.getUser();
    const roleList = Array.isArray(user?.roleProtectedObjectList)
      ? user.roleProtectedObjectList
      : [];
    const protectedObjectName = state.url.split(/[/?#]/).filter(Boolean)[0];
    const hasAccess = roleList.some((role: any) =>
      (role.protectedObjects || []).some(
        (item: any) => item.protectedObjectName === protectedObjectName
      )
    );

    if (hasAccess) {
      return true;
    }

    const roleId = Number(roleList[0]?.roleId);
    return this.router.createUrlTree([roleId === 1 ? '/category' : '/portal']);
  }
}
